export default __webpack_public_path__ + "static/media/latest-editions-3.b8dc8946.png";